// extracted by mini-css-extract-plugin
export default {"home":"Home_home__MJf3q","whatsapp_float":"Home_whatsapp_float__33Mnt","whatsapp_icon":"Home_whatsapp_icon__mgLXz"};